// 通用文件上传工具
// 接口：POST /administrator/index/img/upload
// 字段名：img（FormData）
// 适用于图片 / HTML / PDF / 视频等任意文件，统一返回上传后的访问地址 src。
import axios from 'axios'
import http from './http.js'

const overallUrl = http.overallUrl

/**
 * 上传单个文件
 * @param {File|Blob} file 要上传的文件
 * @param {(percent:number)=>void} [onUploadProgress] 上传进度回调(0-100)
 * @returns {Promise<string>} 上传成功后的文件访问地址 src
 */
export function uploadFile(file, onUploadProgress) {
  const form = new FormData()
  form.append('img', file)
  return axios.post(overallUrl + '/administrator/index/img/upload', form, {
    onUploadProgress: e => {
      if (onUploadProgress && e.total) {
        onUploadProgress(Math.round((e.loaded / e.total) * 100))
      }
    },
  }).then(res => {
    const body = res.data || {}
    if (body.code === 0 && body.data && body.data.src) {
      return body.data.src
    }
    return Promise.reject(new Error(body.msg || '上传失败'))
  })
}

export default { uploadFile }
